import { RendererMain } from '@lightningjs/renderer';
export let renderer;
export let createShader;
export const getRenderer = () => renderer;
export function startLightningRenderer(options = {}, rootId = 'app') {
    renderer = new RendererMain(options, rootId);
    createShader = renderer.createShader.bind(renderer);
    return renderer;
}
//# sourceMappingURL=lightningInit.js.map